export enum VendorsAccountsTableColumnId {
  VendorAccount = 'name',
  Email = 'email',
  Actions = 'actions',
  Password = 'password',
}
